/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://8081.localport.dealer.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 39);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = PropTypes;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Common", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.Common;
  }
});
Object.defineProperty(exports, "CommonTester", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.CommonTester;
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.createStore;
  }
});

var _wsmCommonData = __webpack_require__(35);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEE = exports.ONLY_AT = exports.MANUFACTURER = exports.DEALERSHIP = exports.CONDITIONAL_SPECIAL_DESCRIPTION = exports.CONDITIONAL_SPECIAL = exports.CONDITIONAL = exports.AVAILABLE_SPECIALS = exports.FOOTNOTE_INDICATOR = void 0;
var FOOTNOTE_INDICATOR = '*';
exports.FOOTNOTE_INDICATOR = FOOTNOTE_INDICATOR;
var AVAILABLE_SPECIALS = 'AVAILABLE_SPECIALS';
exports.AVAILABLE_SPECIALS = AVAILABLE_SPECIALS;
var CONDITIONAL = 'CONDITIONAL';
exports.CONDITIONAL = CONDITIONAL;
var CONDITIONAL_SPECIAL = 'CONDITIONAL_SPECIAL';
exports.CONDITIONAL_SPECIAL = CONDITIONAL_SPECIAL;
var CONDITIONAL_SPECIAL_DESCRIPTION = 'CONDITIONAL_SPECIAL_DESCRIPTION';
exports.CONDITIONAL_SPECIAL_DESCRIPTION = CONDITIONAL_SPECIAL_DESCRIPTION;
var DEALERSHIP = 'DEALERSHIP';
exports.DEALERSHIP = DEALERSHIP;
var MANUFACTURER = 'MANUFACTURER';
exports.MANUFACTURER = MANUFACTURER;
var ONLY_AT = 'ONLY_AT';
exports.ONLY_AT = ONLY_AT;
var SEE = 'SEE';
exports.SEE = SEE;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = ReactBootstrap;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_ACCOUNT = exports.SET_WIDGET_INFO = exports.VCDA_ERROR = exports.SET_INCENTIVES = void 0;
// This file should only contain action type constants.
var SET_INCENTIVES = 'SET_INCENTIVES';
exports.SET_INCENTIVES = SET_INCENTIVES;
var VCDA_ERROR = 'VCDA_ERROR';
exports.VCDA_ERROR = VCDA_ERROR;
var SET_WIDGET_INFO = 'SET_WIDGET_INFO';
exports.SET_WIDGET_INFO = SET_WIDGET_INFO;
var SET_ACCOUNT = 'SET_ACCOUNT';
exports.SET_ACCOUNT = SET_ACCOUNT;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactBootstrap = __webpack_require__(4);

var _IncentiveLink = _interopRequireDefault(__webpack_require__(9));

var _constants = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var IncentiveDetail =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IncentiveDetail, _React$Component);

  function IncentiveDetail() {
    _classCallCheck(this, IncentiveDetail);

    return _possibleConstructorReturn(this, _getPrototypeOf(IncentiveDetail).apply(this, arguments));
  }

  _createClass(IncentiveDetail, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentives = _this$props.incentives,
          labels = _this$props.labels,
          heading = _this$props.heading,
          headingInfo = _this$props.headingInfo,
          footnoteConditional = _this$props.footnoteConditional,
          isMobile = _this$props.isMobile,
          showModal = _this$props.showModal;
      var incentivesList = null;

      if (incentives.length) {
        var body = incentives.map(function (incentive) {
          var key = incentive.key;
          return _react.default.createElement(_IncentiveLink.default, {
            key: key,
            incentive: incentive,
            showModal: showModal,
            showFootnote: footnoteConditional && incentive.conditional
          });
        }); // Add heading and tooltip if needed

        var listHeading;
        var headingTooltip;

        if (heading) {
          if (headingInfo) {
            var popoverPlacement = isMobile ? 'top' : 'left';

            var popoverHoverFocus = _react.default.createElement(_reactBootstrap.Popover, {
              id: "incentive-detail-popover"
            }, labels.get(_constants.CONDITIONAL_SPECIAL_DESCRIPTION));

            headingTooltip = _react.default.createElement(_reactBootstrap.OverlayTrigger, {
              trigger: ['hover', 'focus'],
              placement: popoverPlacement,
              overlay: popoverHoverFocus
            }, _react.default.createElement("span", null, _react.default.createElement("i", {
              className: "ddc-icon ddc-icon-info text-muted d-inline-block pl-1"
            })));
          }

          listHeading = _react.default.createElement("h5", {
            className: "pt-3"
          }, heading, headingTooltip);
        }

        incentivesList = _react.default.createElement("div", null, listHeading, _react.default.createElement("ul", {
          className: "list-unstyled line-height-condensed mb-0"
        }, body));
      }

      return incentivesList;
    }
  }]);

  return IncentiveDetail;
}(_react.default.Component);

IncentiveDetail.propTypes = {
  incentives: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    label: _propTypes.default.string,
    offerDetails: _propTypes.default.string,
    shortTitle: _propTypes.default.string,
    disclaimer: _propTypes.default.string,
    effectiveDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string,
    conditional: _propTypes.default.bool,
    manufacturerOffer: _propTypes.default.bool
  }).isRequired).isRequired,
  labels: _propTypes.default.shape({
    get: _propTypes.default.func
  }).isRequired,
  heading: _propTypes.default.string,
  headingInfo: _propTypes.default.string,
  showModal: _propTypes.default.func.isRequired,
  footnoteConditional: _propTypes.default.bool,
  isMobile: _propTypes.default.bool.isRequired
};
IncentiveDetail.defaultProps = {
  heading: '',
  headingInfo: '',
  footnoteConditional: false
};
var _default = IncentiveDetail;
exports.default = _default;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactDom = __webpack_require__(36);

var _WidgetWrapper = _interopRequireDefault(__webpack_require__(23));

var _store = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React hydrate bound to the redux store
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		WS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */
var getFlag = function getFlag(name, defaultValue) {
  if (!window.DDC || !window.DDC.Flags) {
    return defaultValue;
  }

  return window.DDC.Flags[name];
};

var serveBundleFromClientSite = getFlag('serve-osiris-bundle-from-clientsite', false) === true;
var stateParentKey = serveBundleFromClientSite ? 'WS' : 'OSIRIS';

var getWidgetStatesByType = function getWidgetStatesByType(widgetName) {
  if (!window.DDC || !window.DDC[stateParentKey] || !window.DDC[stateParentKey].state || !window.DDC[stateParentKey].state[widgetName]) {
    return {};
  }

  return window.DDC[stateParentKey].state[widgetName];
};

var getWidgetState = function getWidgetState(widgetStates, widgetId) {
  var preloadedState = widgetStates[widgetId];

  if (typeof preloadedState === 'string') {
    preloadedState = JSON.parse(preloadedState);
  }

  return preloadedState;
};

var widgetIdToStore = {};

var initializeWidgets = function initializeWidgets() {
  var widgetStates = getWidgetStatesByType('ws-detailed-incentives');
  var widgetIds = Object.keys(widgetStates);
  widgetIds.forEach(function (widgetId) {
    var store = (0, _store.createStore)(getWidgetState(widgetStates, widgetId));
    widgetIdToStore[widgetId] = store; // When the widget is initially rendered server-side, render.jsx passes outputWrapperDiv
    // to render the widget wrapper div. Here, when hydrating, we pass outputWrapperDiv=false.
    // This is because hydrate takes a DOM element to hydrate into. We can't wrap the widget
    // in an extra div to target because there is a lot of styling in our system that
    // breaks. So, instead, we have to target the widget wrapper div and hydrate the
    // components inside of it.

    (0, _reactDom.hydrate)(React.createElement(_WidgetWrapper.default, {
      outputWrapperDiv: false,
      store: store,
      widgetId: widgetId
    }), document.getElementById("".concat(widgetId, "-app-root"))); // We've initialized. We don't need to keep this data around anymore.
    // Deleting it ensures that we don't accidentally reinitialize later.

    if (serveBundleFromClientSite) {
      delete widgetStates[widgetId];
    }
  });
};

if (serveBundleFromClientSite) {
  initializeWidgets();
} else if (window.DDC && window.DDC.Events && window.DDC.Events['inline-js-available']) {
  initializeWidgets();
} else {
  $(document).on('inlineJSAvailable', initializeWidgets);
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(2);

var _constants = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var IncentiveLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IncentiveLink, _React$Component);

  function IncentiveLink(props) {
    var _this;

    _classCallCheck(this, IncentiveLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IncentiveLink).call(this, props));
    _this.getOfferTitle = _this.getOfferTitle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(IncentiveLink, [{
    key: "getOfferTitle",
    value: function getOfferTitle(prefs, labels) {
      var _this$props$incentive = this.props.incentive,
          title = _this$props$incentive.title,
          shortTitle = _this$props$incentive.shortTitle;
      var offerTitle;

      switch (prefs.incentiveTitleDisplay) {
        case 'regular':
          offerTitle = title;
          break;

        case 'custom':
          offerTitle = labels.get(prefs.incentiveTitleCustom) || labels.get(_constants.DEALER_OFFER);
          break;

        default:
          offerTitle = shortTitle;
      }

      return offerTitle;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          incentive = _this$props.incentive,
          showModal = _this$props.showModal,
          showFootnote = _this$props.showFootnote;
      var footnoteIndicator = null;

      if (showFootnote) {
        footnoteIndicator = _react.default.createElement("span", {
          className: "footnote-indicator"
        }, _constants.FOOTNOTE_INDICATOR);
      }

      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var prefs = _ref.prefs,
              labels = _ref.labels;
          return _react.default.createElement("li", {
            className: "py-3 my-0"
          }, _react.default.createElement("button", {
            className: "text-link text-left",
            onClick: function onClick() {
              return showModal(incentive);
            }
          }, _react.default.createElement("span", {
            className: "incentive-title"
          }, _this2.getOfferTitle(prefs, labels)), footnoteIndicator));
        }
      });
    }
  }]);

  return IncentiveLink;
}(_react.default.Component);

exports.default = IncentiveLink;
IncentiveLink.propTypes = {
  incentive: _propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string.isRequired,
    shortTitle: _propTypes.default.string.isRequired
  }).isRequired,
  showModal: _propTypes.default.func.isRequired,
  showFootnote: _propTypes.default.bool
};
IncentiveLink.defaultProps = {
  showFootnote: false
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactBootstrap = __webpack_require__(4);

var _common = __webpack_require__(2);

var _constants = __webpack_require__(3);

var _analytics = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styles = {
  expandedIconStyle: 'collapse',
  collapsedIconStyle: 'expand'
};

var IncentiveWrapper =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IncentiveWrapper, _React$Component);

  function IncentiveWrapper(props) {
    var _this;

    _classCallCheck(this, IncentiveWrapper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IncentiveWrapper).call(this, props));
    _this.state = {
      isExpanded: false
    };
    return _this;
  }

  _createClass(IncentiveWrapper, [{
    key: "toggleExpand",
    value: function toggleExpand() {
      var _this$props = this.props,
          labels = _this$props.labels,
          incentiveCount = _this$props.incentiveCount,
          widgetName = _this$props.widgetName,
          windowId = _this$props.windowId;
      var title = "".concat(labels.SEE, " ").concat(incentiveCount, " ").concat(labels.AVAILABLE_SPECIALS);
      var isExpanded = !this.state.isExpanded;
      (0, _analytics.toggleSpecialsEvent)(widgetName, windowId, title, isExpanded);
      this.setState({
        isExpanded: isExpanded
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isMobile = this.props.isMobile;
      var paddingClasses = isMobile ? 'pb-3 pt-0' : 'py-3';
      var expandedIconStyle = styles.expandedIconStyle,
          collapsedIconStyle = styles.collapsedIconStyle;
      var icon = this.state.isExpanded ? expandedIconStyle : collapsedIconStyle;

      var panelTitle = _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var labels = _ref.labels;
          return "".concat(labels.get(_constants.SEE), "\n\t\t\t\t\t\t").concat(_this2.props.incentiveCount, "\n\t\t\t\t\t\t").concat(labels.get(_constants.AVAILABLE_SPECIALS));
        }
      });

      var panelHeader = _react.default.createElement("h4", null, _react.default.createElement("div", {
        className: "text-primary font-weight-bold ".concat(paddingClasses)
      }, _react.default.createElement("i", {
        className: "ddc-icon icon-style-collapse ddc-icon-".concat(icon, " d-inline mr-3")
      }), panelTitle));

      return _react.default.createElement(_reactBootstrap.Panel, {
        className: "mb-0 border-0",
        onToggle: this.toggleExpand.bind(this)
      }, _react.default.createElement(_reactBootstrap.Panel.Heading, null, _react.default.createElement(_reactBootstrap.Panel.Title, {
        toggle: true
      }, panelHeader)), _react.default.createElement(_reactBootstrap.Panel.Collapse, null, _react.default.createElement(_reactBootstrap.Panel.Body, null, this.props.children)));
    }
  }]);

  return IncentiveWrapper;
}(_react.default.Component);

IncentiveWrapper.propTypes = {
  incentiveCount: _propTypes.default.number.isRequired,
  isMobile: _propTypes.default.bool.isRequired,
  children: _propTypes.default.element.isRequired,
  windowId: _propTypes.default.string.isRequired,
  widgetName: _propTypes.default.string.isRequired,
  labels: _propTypes.default.shape({
    SEE: _propTypes.default.string.isRequired,
    AVAILABLE_SPECIALS: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = IncentiveWrapper;
exports.default = _default;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _reactBootstrap = __webpack_require__(4);

var _common = __webpack_require__(2);

var _IncentiveDetail = _interopRequireDefault(__webpack_require__(6));

var _constants = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var IncentivesCategorized =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IncentivesCategorized, _React$Component);

  function IncentivesCategorized() {
    _classCallCheck(this, IncentivesCategorized);

    return _possibleConstructorReturn(this, _getPrototypeOf(IncentivesCategorized).apply(this, arguments));
  }

  _createClass(IncentivesCategorized, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          categorizedIncentives = _this$props.categorizedIncentives,
          separateConditional = _this$props.separateConditional,
          showModal = _this$props.showModal,
          isMobile = _this$props.isMobile,
          accountName = _this$props.accountName;

      if (separateConditional) {
        return _react.default.createElement(_common.Common, {
          render: function render(_ref) {
            var labels = _ref.labels;
            var dealerHeading = accountName ? "".concat(labels.get(_constants.ONLY_AT), " ").concat(accountName) : "".concat(labels.get(_constants.DEALERSHIP));
            var dealerHeadingConditional = accountName ? "".concat(labels.get(_constants.ONLY_AT), " ").concat(accountName, "\n\t\t\t\t\t\t\t\t(").concat(labels.get(_constants.CONDITIONAL), ")") : "".concat(labels.get(_constants.DEALERSHIP), "\n\t\t\t\t\t\t\t\t(").concat(labels.get(_constants.CONDITIONAL), ")");
            return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_IncentiveDetail.default, {
              incentives: categorizedIncentives.dealer.regular,
              labels: labels,
              heading: dealerHeading,
              isMobile: isMobile,
              showModal: showModal
            }), _react.default.createElement(_IncentiveDetail.default, {
              incentives: categorizedIncentives.oem.regular,
              labels: labels,
              heading: labels.get(_constants.MANUFACTURER),
              isMobile: isMobile,
              showModal: showModal
            }), _react.default.createElement(_IncentiveDetail.default, {
              incentives: categorizedIncentives.dealer.conditional,
              labels: labels,
              heading: dealerHeadingConditional,
              headingInfo: "info-label",
              isMobile: isMobile,
              showModal: showModal
            }), _react.default.createElement(_IncentiveDetail.default, {
              incentives: categorizedIncentives.oem.conditional,
              labels: labels,
              heading: "".concat(labels.get(_constants.MANUFACTURER), " (").concat(labels.get(_constants.CONDITIONAL), ")"),
              headingInfo: "info-label",
              isMobile: isMobile,
              showModal: showModal
            }));
          }
        });
      } else {
        return _react.default.createElement(_common.Common, {
          render: function render(_ref2) {
            var labels = _ref2.labels;
            var dealerHeading = accountName ? "".concat(labels.get(_constants.ONLY_AT), " ").concat(accountName) : "".concat(labels.get(_constants.DEALERSHIP));
            var popoverPlacement = isMobile ? 'top' : 'left';

            var popoverHoverFocus = _react.default.createElement(_reactBootstrap.Popover, {
              id: "incentive-detail-popover"
            }, labels.get(_constants.CONDITIONAL_SPECIAL_DESCRIPTION));

            return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_IncentiveDetail.default, {
              incentives: categorizedIncentives.dealer.regular.concat(categorizedIncentives.dealer.conditional),
              labels: labels,
              heading: dealerHeading,
              isMobile: isMobile,
              footnoteConditional: true,
              showModal: showModal
            }), _react.default.createElement(_IncentiveDetail.default, {
              incentives: categorizedIncentives.oem.regular.concat(categorizedIncentives.oem.conditional),
              labels: labels,
              heading: labels.get(_constants.MANUFACTURER),
              isMobile: isMobile,
              footnoteConditional: true,
              showModal: showModal
            }), _react.default.createElement("div", {
              className: "ddc-font-size-small mt-4 text-muted"
            }, _constants.FOOTNOTE_INDICATOR, labels.get(_constants.CONDITIONAL_SPECIAL), _react.default.createElement(_reactBootstrap.OverlayTrigger, {
              trigger: ['hover', 'focus'],
              placement: popoverPlacement,
              overlay: popoverHoverFocus
            }, _react.default.createElement("span", null, _react.default.createElement("i", {
              className: "ddc-icon ddc-icon-info text-muted d-inline-block pl-2"
            })))));
          }
        });
      }
    }
  }]);

  return IncentivesCategorized;
}(_react.default.Component);

IncentivesCategorized.propTypes = {
  categorizedIncentives: _propTypes.default.shape({
    dealer: _propTypes.default.shape({
      regular: _propTypes.default.array,
      conditional: _propTypes.default.array
    }),
    oem: _propTypes.default.shape({
      regular: _propTypes.default.array,
      conditional: _propTypes.default.array
    })
  }).isRequired,
  separateConditional: _propTypes.default.bool.isRequired,
  showModal: _propTypes.default.func.isRequired,
  isMobile: _propTypes.default.bool.isRequired,
  accountName: _propTypes.default.string.isRequired
};
var _default = IncentivesCategorized;
exports.default = _default;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WidgetContainer = void 0;

var _reactRedux = __webpack_require__(7);

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _react = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(2);

var _wsmIncentiveModal = __webpack_require__(34);

var _IncentivesCategorized = _interopRequireDefault(__webpack_require__(11));

var _IncentiveDetail = _interopRequireDefault(__webpack_require__(6));

var _IncentiveWrapper = _interopRequireDefault(__webpack_require__(10));

__webpack_require__(30);

var _utility = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var WidgetContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetContainer, _React$Component);

  function WidgetContainer(props) {
    var _this;

    _classCallCheck(this, WidgetContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetContainer).call(this, props));
    _this.state = {
      incentive: {},
      isModalVisible: false
    };
    _this.showModal = _this.showModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.hideModal = _this.hideModal.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetContainer, [{
    key: "showModal",
    value: function showModal(incentive) {
      this.setState({
        incentive: incentive,
        isModalVisible: true
      });
    }
  }, {
    key: "hideModal",
    value: function hideModal() {
      // deliberately do not reset the incentive so that
      // that data doesn't disappear as it slides off the screen,
      // esp. for mobile dock
      this.setState({
        isModalVisible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var rootComponent = null;
      var _this$props = this.props,
          incentives = _this$props.incentives,
          widgetInfo = _this$props.widgetInfo,
          account = _this$props.account,
          labels = _this$props.labels,
          prefs = _this$props.prefs; // remove locale when when <Common /> is added to module

      var windowId = widgetInfo.windowId,
          widgetName = widgetInfo.widgetName,
          deviceType = widgetInfo.deviceType,
          locale = widgetInfo.locale;
      var isMobile = deviceType === 'MOBILE';
      var accountName = account ? account.name : null;

      if (incentives && incentives.length > 0) {
        var filteredIncentives = (0, _utility.filterIncentives)(incentives, prefs);
        var incentiveCount = filteredIncentives.length;

        if (incentiveCount) {
          // We have incentives to display
          var dialog = _react.default.createElement(_common.Common, {
            render: function render(_ref) {
              var sitemap = _ref.sitemap;
              return _react.default.createElement(_wsmIncentiveModal.IncentiveModal, {
                incentive: _this2.state.incentive,
                isOpen: _this2.state.isModalVisible,
                isMobile: isMobile,
                onModalClose: _this2.hideModal,
                widgetInfo: widgetInfo,
                account: account,
                newListingPath: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_NEW'),
                usedListingPath: sitemap.get('INVENTORY_LISTING_DEFAULT_AUTO_USED') // remove locale when when <Common /> is added to module
                ,
                locale: locale,
                prefs: prefs
              });
            }
          });

          if (incentiveCount === 1) {
            // Display single incentive
            rootComponent = _react.default.createElement("div", null, _react.default.createElement(_IncentiveDetail.default, {
              incentives: filteredIncentives,
              labels: labels,
              heading: "",
              isMobile: isMobile,
              showModal: this.showModal
            }), dialog);
          } else if (prefs.incentiveDisplayGrouping === 'none') {
            // Display list of incentives with no headings
            rootComponent = _react.default.createElement("div", null, _react.default.createElement(_IncentiveWrapper.default, {
              incentiveCount: incentiveCount,
              isMobile: isMobile,
              windowId: windowId,
              widgetName: widgetName,
              labels: labels
            }, _react.default.createElement(_IncentiveDetail.default, {
              incentives: filteredIncentives,
              labels: labels,
              heading: "",
              isMobile: isMobile,
              showModal: this.showModal
            })), dialog);
          } else {
            // Display grouped list of incentives, with headings
            rootComponent = _react.default.createElement("div", null, _react.default.createElement(_IncentiveWrapper.default, {
              incentiveCount: incentiveCount,
              isMobile: isMobile,
              windowId: windowId,
              widgetName: widgetName,
              labels: labels
            }, _react.default.createElement(_IncentivesCategorized.default, {
              categorizedIncentives: (0, _utility.categorizeIncentives)(filteredIncentives),
              separateConditional: prefs.incentiveDisplayGrouping === 'type-and-conditional',
              labels: labels,
              isMobile: isMobile,
              accountName: accountName,
              showModal: this.showModal
            })), dialog);
          }
        }
      }

      return rootComponent;
    }
  }]);

  return WidgetContainer;
}(_react.default.Component);

exports.WidgetContainer = WidgetContainer;
WidgetContainer.propTypes = {
  incentives: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    title: _propTypes.default.string,
    label: _propTypes.default.string,
    offerDetails: _propTypes.default.string,
    shortTitle: _propTypes.default.string,
    disclaimer: _propTypes.default.string,
    effectiveDate: _propTypes.default.string,
    expirationDate: _propTypes.default.string,
    conditional: _propTypes.default.bool,
    make: _propTypes.default.string,
    condition: _propTypes.default.string,
    manufacturerOffer: _propTypes.default.bool,
    specific: _propTypes.default.object
  }).isRequired).isRequired,
  widgetInfo: _propTypes.default.shape({
    windowId: _propTypes.default.string.isRequired,
    widgetName: _propTypes.default.string.isRequired,
    deviceType: _propTypes.default.string.isRequired,
    // remove locale when when <Common /> is added to module
    locale: _propTypes.default.string.isRequired
  }).isRequired,
  account: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string
  }).isRequired,
  labels: _propTypes.default.shape({}).isRequired,
  prefs: _propTypes.default.shape({
    incentiveDisplayGrouping: _propTypes.default.string
  }).isRequired,
  flags: _propTypes.default.shape({}).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    incentives: state.incentives,
    widgetInfo: state.requestData,
    account: state.account,
    labels: state.labels,
    prefs: state.prefs,
    flags: state.flags
  };
};

var mapDispatchToProps = function mapDispatchToProps(_dispatch) {
  return {};
};

var Widget = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);
var _default = Widget;
exports.default = _default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [];
exports.default = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = account;

var _types = __webpack_require__(5);

function account() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload && action.type === _types.SET_ACCOUNT) {
    return action.payload;
  }

  return state;
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = incentive;

var _types = __webpack_require__(5);

function incentive() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error) {
    var incentives = action.payload;

    switch (action.type) {
      // case GET_INCENTIVES:
      // 	return {...state}  ;
      case _types.SET_INCENTIVES:
        return incentives;

      default:
    }
  }

  return state;
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _incentives = _interopRequireDefault(__webpack_require__(15));

var _account = _interopRequireDefault(__webpack_require__(14));

var _widgetInfo = _interopRequireDefault(__webpack_require__(18));

var _vcdaError = _interopRequireDefault(__webpack_require__(17));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = {
  incentives: _incentives.default,
  account: _account.default,
  widgetInfo: _widgetInfo.default,
  vcdaError: _vcdaError.default
};
var _default = root;
exports.default = _default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = vcdaError;

var _types = __webpack_require__(5);

function vcdaError() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _types.VCDA_ERROR:
      return {
        error: action.payload.error
      };
    // no default
  }

  return state;
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// import { SET_WIDGET_INFO } from '../actions/types';
//
// export default function widgetInfo(state = {}, action) {
// 	if (!action.error && action.payload) {
// 		switch (action.type) {
// 			case SET_WIDGET_INFO:
// 				return action.payload;
// 			// no default
// 		}
// 	}
//
// 	return state;
// }


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeSpecialsDetailsEvent = closeSpecialsDetailsEvent;
exports.toggleSpecialsEvent = toggleSpecialsEvent;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultClickEvent = {
  event: 'widgetUserEvent',
  element: 'More details button',
  elementCTA: 'Details',
  action: 'clicked',
  result: 'Revealed detail information popup',
  widgetName: 'ws-detailed-incentives',
  widgetId: 'detailed-incentives1',
  widgetState: 'default',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
  var trackingObject = window.jQuery(document) || {};

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }
}

function closeSpecialsDetailsEvent(widgetName, widgetId) {
  var eventData = {
    element: 'Close button',
    elementCTA: undefined,
    action: 'clicked',
    result: 'Closed dialog',
    widgetState: 'Special dialog',
    widgetName: widgetName,
    widgetId: widgetId
  };
  trackGoogleAnalyticsEvent(eventData);
}

function toggleSpecialsEvent(widgetName, widgetId, elementCTA, toggleState) {
  var eventData = {
    widgetName: widgetName,
    widgetId: widgetId,
    elementCTA: elementCTA,
    element: 'Available specials accordion',
    result: "Available specials ".concat(toggleState ? 'expanded' : 'collapsed')
  };
  trackGoogleAnalyticsEvent(eventData);
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSiteId = getSiteId;
exports.getDeviceType = getDeviceType;
exports.getIncentivesCap = getIncentivesCap;
exports.getAccountId = getAccountId;
exports.filterIncentives = filterIncentives;
exports.categorizeIncentives = categorizeIncentives;
exports.getSearchRO = void 0;

/**
 * create formatted search request object
 * @param {string} vehicleId
 * @param {string} accountId
 * @returns {object} formatted search request object
 */
var getSearchRO = function getSearchRO(vehicleId) {
  return {
    vehicleIncentives: {
      uuid: vehicleId
    }
  };
};

exports.getSearchRO = getSearchRO;

function getSiteId(rData) {
  return rData.parameterMap && rData.parameterMap.siteId || rData.siteId;
}

function getDeviceType(rData) {
  return rData.parameterMap && rData.parameterMap.deviceType || rData.deviceType;
}

function getIncentivesCap(rData) {
  var incentivesCap = rData.parameterMap && rData.parameterMap.incentivesCap || -1;
  return Number.isNaN(Number(incentivesCap)) ? -1 : Number(incentivesCap);
}

function getAccountId(rData) {
  return rData.parameterMap && rData.parameterMap.accountId || rData.accountId;
} // Return only the categories specified by preferences


function filterIncentives(incentives, prefs) {
  var filteredIncentives = [];
  incentives.forEach(function (incentive) {
    var creator = incentive.manufacturerOffer ? 'oem' : 'dealer';
    var type = incentive.conditional ? 'conditional' : 'regular';

    if (creator === 'oem' && type === 'regular' && prefs.showOemNationalIncentives === 'true' || creator === 'oem' && type === 'conditional' && prefs.showOemConditionalIncentives === 'true' || creator === 'dealer' && type === 'regular' && prefs.showDealerRegularIncentives === 'true' || creator === 'dealer' && type === 'conditional' && prefs.showDealerConditionalIncentives === 'true') {
      filteredIncentives.push(incentive);
    }
  });
  return filteredIncentives;
} // Return object containing incentives broken out by category


function categorizeIncentives(incentives) {
  var categorizedIncentives = {
    oem: {
      regular: [],
      conditional: []
    },
    dealer: {
      regular: [],
      conditional: []
    }
  };
  incentives.forEach(function (incentive) {
    var creator = incentive.manufacturerOffer ? 'oem' : 'dealer';
    var type = incentive.conditional ? 'conditional' : 'regular';
    categorizedIncentives[creator][type].push(incentive);
  });
  return categorizedIncentives;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapse = function Collapse(props) {
  var id = props.id,
      children = props.children,
      toggleCollapse = props.toggleCollapse;

  if (toggleCollapse) {
    return _react.default.createElement("div", {
      id: "".concat(id, "-collapse"),
      className: "collapse collapse-content"
    }, children);
  }

  return children;
};

Collapse.propTypes = {
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  toggleCollapse: _propTypes.default.bool
};
Collapse.defaultProps = {
  toggleCollapse: false
};
var _default = Collapse;
exports.default = _default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _common = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// eslint-disable-line import/no-unresolved
var WidgetHeading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetHeading, _React$Component);

  function WidgetHeading(props) {
    var _this;

    _classCallCheck(this, WidgetHeading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetHeading).call(this, props));
    _this.renderDelegate = _this.renderDelegate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetHeading, [{
    key: "renderDelegate",
    value: function renderDelegate(_ref) {
      var labels = _ref.labels;
      var _this$props = this.props,
          HeadingTag = _this$props.HeadingTag,
          headingText = _this$props.headingText,
          widgetId = _this$props.widgetId,
          toggleCollapse = _this$props.toggleCollapse,
          showIcon = _this$props.showIcon,
          headingClasses = _this$props.headingClasses,
          iconClasses = _this$props.iconClasses;

      var allIconClasses = _toConsumableArray(iconClasses);

      var collapseAttributes = {};

      if (toggleCollapse) {
        var iconExpand = 'ddc-icon-expand';
        allIconClasses.push(iconExpand);
        allIconClasses.push('icon-style-collapse');
        collapseAttributes = {
          role: 'button',
          'data-toggle': 'collapse',
          'data-target': "#".concat(widgetId, "-collapse"),
          'data-expand-icon-class': "".concat(iconExpand),
          'data-collapse-icon-class': 'ddc-icon-collapse',
          'aria-expanded': 'false',
          'aria-controls': "".concat(widgetId, "-collapse")
        };
      }

      return _react.default.createElement(HeadingTag, _extends({
        className: headingClasses.join(' ')
      }, collapseAttributes), showIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("i", {
        className: allIconClasses.join(' ')
      }), ' '), labels.getHTML(headingText));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.headingText || this.props.headingText.toUpperCase() === 'FALSE') {
        return null;
      } else {
        return _react.default.createElement(_common.Common, {
          render: this.renderDelegate
        });
      }
    }
  }]);

  return WidgetHeading;
}(_react.default.Component);

WidgetHeading.propTypes = {
  HeadingTag: _propTypes.default.string,
  headingText: _propTypes.default.string,
  widgetId: _propTypes.default.string.isRequired,
  toggleCollapse: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  headingClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  iconClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
WidgetHeading.defaultProps = {
  HeadingTag: 'h3',
  headingText: ''
};
var _default = WidgetHeading;
exports.default = _default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _root = __webpack_require__(31);

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(7);

var _WidgetHeading = _interopRequireDefault(__webpack_require__(22));

var _Collapse = _interopRequireDefault(__webpack_require__(21));

var _Widget = _interopRequireDefault(__webpack_require__(12));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: The eslint-disable-line is needed because this file won't lint
// when it's in the ws-scripts repo because the file only exists in the
// widget. It's safe because the entire application won't work if the
// file wasn't really resolved. It would be really apparent quickly.
// eslint-disable-line import/no-unresolved
var getWidgetClasses = function getWidgetClasses(widgetClasses, widgetName, toggleCollapse) {
  var classes = ['ddc-content', widgetName];

  if (widgetClasses) {
    classes.push(widgetClasses);
  }

  if (toggleCollapse) {
    classes.push('collapse-container');
  }

  return classes;
};

var getIconClasses = function getIconClasses(prefs, showIcon, toggleCollapse) {
  var iconClasses = [];
  var widgetHeading = prefs.widgetHeading,
      headingIconClasses = prefs.headingIconClasses,
      headingIconSize = prefs.headingIconSize,
      headingIconStyle = prefs.headingIconStyle;

  if (widgetHeading && showIcon) {
    iconClasses.push('ddc-icon');

    if (!toggleCollapse) {
      iconClasses.push("ddc-icon-".concat(headingIconStyle));
    }

    if (headingIconSize) {
      iconClasses.push("ddc-icon-size-".concat(headingIconSize));
    }

    if (headingIconClasses) {
      iconClasses.push(headingIconClasses);
    }
  }

  return iconClasses;
};

var getHeadingClasses = function getHeadingClasses(prefs, deviceType, toggleCollapse) {
  var headingClasses = [];
  var headingSize = prefs.headingSize,
      headingStyles = prefs.headingStyles;
  headingClasses.push('widget-heading');

  if (deviceType === 'MOBILE') {
    headingClasses.push('ddc-heading');
  }

  if (headingSize) {
    headingClasses.push(headingSize);
  }

  if (headingStyles) {
    headingClasses.push("ddc-heading-".concat(headingStyles));
  }

  if (toggleCollapse) {
    headingClasses.push('collapse-heading');
  }

  return headingClasses;
};

var WidgetWrapper = function WidgetWrapper(_ref) {
  var outputWrapperDiv = _ref.outputWrapperDiv,
      store = _ref.store,
      widgetId = _ref.widgetId,
      widgetName = _ref.widgetName;
  var state = store.getState();
  var prefs = state.prefs || {};
  var toggleCollapse = prefs.widgetHeading && prefs.toggleCollapse === 'true' || false;
  var showIcon = prefs.headingIconStyle ? true : toggleCollapse;

  var wrapping = _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react.default.createElement(_WidgetHeading.default, {
    HeadingTag: prefs.headingTag,
    headingText: prefs.widgetHeading,
    widgetId: widgetId,
    toggleCollapse: toggleCollapse,
    showIcon: showIcon,
    headingClasses: getHeadingClasses(prefs, state.requestData.deviceType, toggleCollapse),
    iconClasses: getIconClasses(prefs, showIcon, toggleCollapse)
  }), _react.default.createElement(_Collapse.default, {
    id: widgetId,
    toggleCollapse: toggleCollapse
  }, _react.default.createElement(_Widget.default, null)));

  if (outputWrapperDiv) {
    if (!widgetName) {
      throw new Error('widgetName is required if outputWrapperDiv is true.');
    }

    return _react.default.createElement("div", {
      id: "".concat(widgetId, "-app-root"),
      className: getWidgetClasses(prefs.widgetClasses, widgetName, toggleCollapse).join(' '),
      "data-widget-name": widgetName,
      "data-widget-id": widgetId
    }, wrapping);
  }

  return wrapping;
};

WidgetWrapper.propTypes = {
  outputWrapperDiv: _propTypes.default.bool.isRequired,
  store: _propTypes.default.shape({
    getState: _propTypes.default.func.isRequired
  }).isRequired,
  widgetId: _propTypes.default.string.isRequired,
  widgetName: _propTypes.default.string
};
var _default = WidgetWrapper;
exports.default = _default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flags;

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labels;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_LABELS':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefs;

function prefs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_PREFS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestData;

function requestData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_REQUEST_DATA':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitemap;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sitemap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_SITEMAP':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(37);

var _reduxThunk = _interopRequireDefault(__webpack_require__(38));

var _reducers = _interopRequireDefault(__webpack_require__(16));

var _requestData = _interopRequireDefault(__webpack_require__(27));

var _prefs = _interopRequireDefault(__webpack_require__(26));

var _labels = _interopRequireDefault(__webpack_require__(25));

var _sitemap = _interopRequireDefault(__webpack_require__(28));

var _flags = _interopRequireDefault(__webpack_require__(24));

var _middleware = _interopRequireDefault(__webpack_require__(13));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-line import/no-unresolved
var providedReducers = {
  requestData: _requestData.default,
  prefs: _prefs.default,
  labels: _labels.default,
  sitemap: _sitemap.default,
  flags: _flags.default
};
var reducers = (0, _redux.combineReducers)(_objectSpread({}, _reducers.default, providedReducers));

var middleware = _toConsumableArray(_middleware.default).concat([_reduxThunk.default]);

var locationContains = function locationContains(search) {
  return window.location.toString().indexOf(search) !== -1;
};

var isBrowser = typeof window !== 'undefined';
var showReduxLoggerFromUrlParam = isBrowser && (locationContains('_mode=debug') || locationContains('wsScriptsUseReduxLogger=true'));

if (isBrowser && ("production" === 'development' || showReduxLoggerFromUrlParam)) {
  // Note: This must the be last middleware in the chain so that it logs actions
  // instead of thunks or Promises.
  // Use an actionTransformer to get the widget name into the output since
  // we have multiple stores running on one page. It may seem like using
  // titleFormatter makes more sense for this purpose, but doing so loses the
  // readability improvement coloring added in 2.10.0 of redux-logger. As of
  // 3.0.6, there is no way to get colors without using the default title formatter.
  // With the below action transformer and default title formatter, we get:
  // action ws-GENERIC-WIDGET-NAME - MIDDLEWARE_TEST @ 17:47:41.612 (in 0.30 ms)
  var actionTransformer = function actionTransformer(action) {
    return _objectSpread({}, action, {
      type: "ws-detailed-incentives - ".concat(action.type)
    });
  };

  var _require = __webpack_require__(32),
      createLogger = _require.createLogger;

  var logger = createLogger({
    actionTransformer: actionTransformer,
    duration: true
  });
  middleware.push(logger);
}

var enhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middleware));

function createStore(initialState) {
  var store = (0, _redux.createStore)(reducers, initialState, enhancer);

  if (false) {
    module.hot.accept('../reducers', function () {
      var defaultReducers = require('../reducers').default; // eslint-disable-line import/no-unresolved


      store.replaceReducer((0, _redux.combineReducers)(_objectSpread({}, defaultReducers, providedReducers)));
    });
  }

  return store;
}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

if (false) {
  var hot = require('./index').hot;
  if (module.hot) {
    var cache = require.cache;

    if (!module.parents || module.parents.length === 0) {
      throw new Error(
        'React-Hot-Loader: `react-hot-loader/root` is not supported on your system. ' +
        'Please use `import {hot} from "react-hot-loader"` instead'
      );
    }
    // access parent
    var parent = cache[module.parents[0]];
    if (!parent) {
      throw new Error(
        'React-Hot-Loader: `react-hot-loader/root` is not supported on your system. ' +
        'Please use `import {hot} from "react-hot-loader"` instead'
      );
    }
    // remove self from a cache
    delete cache[module.id];
  }
  // setup hot for caller
  exports.hot = hot(parent);
} else {
  // prod mode
  exports.hot = function (a) {
    return a;
  };
}


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 33 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IncentiveModal", function() { return IncentiveModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__);




function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var AND = 'AND';
var OR = 'OR';
var DETAILS = 'DETAILS';
var DISCLAIMER = 'DISCLAIMER';
var PERCENT_APR_FOR = 'PERCENT_APR_FOR';
var PER_MONTH = 'PER_MONTH';
var MONTHS = 'MONTHS';
var CASH_BACK = 'CASH_BACK';
var CASH_DUE_AT_SIGNING = 'CASH_DUE_AT_SIGNING';
var VIEW_APPLICABLE_VEHICLES = 'VIEW_APPLICABLE_VEHICLES';
var CASH_OFFER_FROM = 'CASH_OFFER_FROM';
var FINANCE_AND_CASH_OFFER_FROM = 'FINANCE_AND_CASH_OFFER_FROM';
var FINANCE_OR_CASH_OFFER_FROM = 'FINANCE_OR_CASH_OFFER_FROM';
var FINANCE_OFFER_FROM = 'FINANCE_OFFER_FROM';
var LEASE_OFFER_FROM = 'LEASE_OFFER_FROM';
var PROMOTION_FROM = 'PROMOTION_FROM';

// Temporary list of labels and the "labelObj" class to replicate labels.get() from ws-scripts
// Needed until <Common/> is broken out of ws-scripts for use in modules
var labels = {
  AND: {
    en: 'and',
    es: 'y',
    fr: 'et'
  },
  OR: {
    en: 'or',
    es: 'o',
    fr: 'ou'
  },
  DETAILS: {
    en: 'Details',
    es: 'Detalles',
    fr: 'Détails'
  },
  DISCLAIMER: {
    en: 'Disclaimer',
    es: 'Exención de responsabilidad',
    fr: 'Avertissement'
  },
  EFFECTIVE_THROUGH_X: {
    en: 'Effective through {{END_DATE}}',
    es: 'En vigencia hasta el {{END_DATE}}',
    fr: 'Efficace jusqu\'au {{END_DATE}}'
  },
  EFFECTIVE_X_THROUGH_X: {
    en: 'Effective {{START_DATE}} through {{END_DATE}}',
    es: 'Efectivo desde el {{START_DATE}} hasta el {{END_DATE}}',
    fr: 'En vigueur {{START_DATE}} à {{END_DATE}}'
  },
  PERCENT_APR_FOR: {
    en: '% APR for',
    es: '% tasa de porcentaje anual',
    fr: "% taux d'intérêt annuel"
  },
  PER_MONTH: {
    en: 'per month',
    es: 'por mes',
    fr: 'par mois'
  },
  MONTHS: {
    en: 'months',
    es: 'meses',
    fr: 'mois'
  },
  CASH_BACK: {
    en: 'cash back',
    es: 'reembolso',
    fr: 'argent en remise'
  },
  CASH_DUE_AT_SIGNING: {
    en: 'cash due at signing',
    es: 'pago en efectivo al firmar',
    fr: 'argent dû au moment de la signature'
  },
  VIEW_APPLICABLE_VEHICLES: {
    en: 'view applicable vehicles',
    es: 'ver vehículos aplicables',
    fr: 'voir les véhicules applicables'
  },
  CASH_OFFER_FROM: {
    en: 'Cash Offer from',
    es: 'Oferta en Efectivo de',
    fr: 'Offre en Espèces de'
  },
  FINANCE_AND_CASH_OFFER_FROM: {
    en: 'APR Finance and Cash Offer from',
    es: 'APR Finance y Oferta en Efectivo de',
    fr: 'APR Offre de Financement et en Espèces de'
  },
  FINANCE_OR_CASH_OFFER_FROM: {
    en: 'APR Finance or Cash Offer from',
    es: 'APR Finance o Oferta en Efectivo de',
    fr: 'APR Offre de Financement ou en Espèces de'
  },
  FINANCE_OFFER_FROM: {
    en: 'APR Finance Offer from',
    es: 'APR Finance Offer de',
    fr: 'APR Finance Offre de'
  },
  LEASE_OFFER_FROM: {
    en: 'Lease Offer from',
    es: 'Oferta de arrendamiento de',
    fr: 'Offre de location de'
  },
  PROMOTION_FROM: {
    en: 'Promotion from',
    es: 'Promoción desde',
    fr: 'Promotion à partir de'
  }
};

var LabelObj = function LabelObj() {
  var _this = this;

  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en_US';

  _classCallCheck(this, LabelObj);

  this.locale = locale;

  this.get = function () {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    // Return untranslated label by default
    var translatedLabel = label;

    var language = _this.locale.split('_')[0];

    if (labels[label]) {
      if (labels[label][language]) {
        // Label exists for this language
        translatedLabel = labels[label][language];
      } else if (labels[label].en) {
        // Default to English
        translatedLabel = labels[label].en;
      }
    }

    return translatedLabel;
  };
};

var ListingLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ListingLink, _React$Component);

  // TODO: remove constructor when <Common /> is added for labels
  function ListingLink(props) {
    var _this;

    _classCallCheck(this, ListingLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListingLink).call(this, props));
    var locale = props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass(ListingLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentiveId = _this$props.incentiveId,
          incentiveAccountId = _this$props.incentiveAccountId,
          incentiveName = _this$props.incentiveName,
          condition = _this$props.condition,
          newListingPath = _this$props.newListingPath,
          usedListingPath = _this$props.usedListingPath;
      var url = '';

      if (condition === 'NEW') {
        url = newListingPath;
      } else {
        url = usedListingPath;
      }

      if (url) {
        url = "".concat(url, "?incentiveId=").concat(encodeURIComponent(incentiveId), "&incentiveAccountId=").concat(encodeURIComponent(incentiveAccountId));

        if (condition === 'CERTIFIED') {
          url = "".concat(url, "&compositeType=certified");
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
          className: "small text-capitalize",
          href: url,
          "data-ga-event": "incentives|click|view inventory",
          "data-incentive-id": incentiveId,
          "data-incentive-name": incentiveName
        }, this.labels.get(VIEW_APPLICABLE_VEHICLES));
      } else {
        return null;
      }
    }
  }]);

  return ListingLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
ListingLink.propTypes = {
  incentiveId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  incentiveAccountId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  incentiveName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  newListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  usedListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
ListingLink.defaultProps = {
  incentiveName: '',
  condition: 'NEW',
  newListingPath: null,
  usedListingPath: null
};

function parseIncentiveKey(key) {
  var incentiveInfo = {
    incentiveAccountId: '',
    incentiveId: ''
  };

  if (typeof key === 'string') {
    var keyParsed = key.split('_');

    if (keyParsed.length > 1) {
      incentiveInfo = {
        incentiveAccountId: keyParsed[0],
        incentiveId: keyParsed[1]
      };
    }
  }

  return incentiveInfo;
}
function formatNumber(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';

  if (typeof num !== 'number') {
    return '';
  }

  return new Intl.NumberFormat(locale.replace('_', '-')).format(num);
}
function formatCurrency(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var showFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = {
    style: 'currency',
    currency: locale.length && locale.indexOf('CA') > -1 ? 'CAD' : 'USD'
  };
  var currencyValue;

  if (typeof num !== 'number') {
    return '';
  }

  if (showFractionDigits) {
    // two fraction digits (aka decimal places) by default
    currencyValue = num;
  } else {
    currencyValue = Math.round(num);
    options.minimumFractionDigits = 0;
  }

  return new Intl.NumberFormat(locale.replace('_', '-'), options).format(currencyValue);
}

var TermsList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TermsList, _React$Component);

  // TODO: remove constructor when <Common /> is added for labels
  function TermsList(props) {
    var _this;

    _classCallCheck(this, TermsList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TermsList).call(this, props));
    var locale = _this.props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass(TermsList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          incentiveTerms = _this$props.incentiveTerms,
          locale = _this$props.locale;
      var termsList = null;

      if (incentiveTerms && incentiveTerms.length) {
        var terms;
        incentiveTerms.forEach(function (item) {
          terms = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, terms, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
            className: "list-group-item p-0 pb-1"
          }, "".concat(formatNumber(item.value, locale)).concat(_this2.labels.get(PERCENT_APR_FOR), " ").concat(item.term, " ").concat(_this2.labels.get(MONTHS))));
        });
        termsList = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
          className: "list-group list-group-flush mt-4"
        }, terms);
      }

      return termsList;
    }
  }]);

  return TermsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
TermsList.propTypes = {
  incentiveTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    term: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
  })),
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};
TermsList.defaultProps = {
  incentiveTerms: []
};

var SpecificDetails =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SpecificDetails, _React$Component);

  // TODO: remove constructor when <Common /> is added for labels
  function SpecificDetails(props) {
    var _this;

    _classCallCheck(this, SpecificDetails);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SpecificDetails).call(this, props));
    var locale = _this.props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass(SpecificDetails, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentive = _this$props.incentive,
          locale = _this$props.locale,
          showEffectiveStartDate = _this$props.prefs.showEffectiveStartDate;
      var details = null;

      if (incentive && incentive.specific) {
        var effectiveDate = incentive.effectiveDate,
            expirationDate = incentive.expirationDate,
            specific = incentive.specific;
        var effectiveDates = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, showEffectiveStartDate.toLowerCase() === 'true' ? "".concat(this.labels.get('EFFECTIVE_X_THROUGH_X').replace(/({{\w+_?}})/gm, function (word) {
          if (word === '{{START_DATE}}') return effectiveDate;
          if (word === '{{END_DATE}}') return expirationDate;
        })) : "".concat(this.labels.get('EFFECTIVE_THROUGH_X').replace('{{END_DATE}}', expirationDate)));
        var cashBack = specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(formatCurrency(specific.cashOption, locale), " ").concat(this.labels.get(CASH_BACK))) : null;
        var cashDue = specific.cashDue ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(formatCurrency(specific.cashDue, locale), " ").concat(this.labels.get(CASH_DUE_AT_SIGNING))) : null;
        var payment = specific.monthlyPayment ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(formatCurrency(specific.monthlyPayment, locale), " ").concat(this.labels.get(PER_MONTH)), specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "".concat(formatCurrency(specific.cashOption, locale), " ").concat(this.labels.get(CASH_BACK))) : null) : '';

        if (specific._type) {
          switch (specific._type) {
            case 'CASH':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, cashBack, effectiveDates);
              break;

            case 'FINANCE':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), effectiveDates, cashDue);
              break;

            case 'CASH_AND_FINANCE':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, this.labels.get(AND)), cashBack) : null, effectiveDates, cashDue);
              break;

            case 'CASH_OR_FINANCE':
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), specific.cashOption ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, this.labels.get(OR)), cashBack) : null, effectiveDates, cashDue);
              break;

            case 'LEASE':
              // TODO: Missing "lease term" field from VCDA
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, payment, effectiveDates, cashDue);
              break;

            case 'UNDEFINED_TERM':
              // TODO: Missing "apr" field from VCDA
              details = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, cashBack, effectiveDates, cashDue);
              break;

            default:
              // PROMOTION
              details = effectiveDates;
          }
        }
      }

      return details;
    }
  }]);

  return SpecificDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
SpecificDetails.propTypes = {
  incentive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    offerDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    shortTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    effectiveDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    expirationDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    conditional: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    make: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    manufacturerOffer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    specific: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

var defaultClickEvent = {
  widgetId: '',
  widgetName: 'wsm-incentive-modal',
  widgetState: 'default',
  event: 'widgetUserEvent',
  element: '',
  elementCTA: undefined,
  action: 'clicked',
  result: '',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
  var trackingObject = window.jQuery(document) || {};

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }
}

function viewSpecialsDetailsEvent(widgetName, widgetId, elementCTA) {
  var eventData = {
    widgetId: widgetId,
    widgetName: widgetName,
    element: 'Specials details link',
    elementCTA: elementCTA,
    result: 'Opened dialog'
  };
  trackGoogleAnalyticsEvent(eventData);
}
function closeSpecialsDetailsEvent(widgetName, widgetId) {
  var eventData = {
    widgetId: widgetId,
    widgetName: widgetName,
    widgetState: 'Special dialog',
    element: 'Close button',
    result: 'Closed dialog'
  };
  trackGoogleAnalyticsEvent(eventData);
}

var IncentiveModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IncentiveModal, _React$Component);

  function IncentiveModal(props) {
    var _this;

    _classCallCheck(this, IncentiveModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IncentiveModal).call(this, props)); // TODO: remove LabelObj when <Common /> is added for labels

    var locale = props.locale;
    _this.labels = new LabelObj(locale);
    _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
    _this.onOpen = _this.onOpen.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(IncentiveModal, [{
    key: "onOpen",
    value: function onOpen() {
      var _this$props = this.props,
          incentive = _this$props.incentive,
          _this$props$widgetInf = _this$props.widgetInfo,
          windowId = _this$props$widgetInf.windowId,
          widgetName = _this$props$widgetInf.widgetName; // Track when modal is opened

      if (incentive && Object.keys(incentive).length > 0) {
        var title = incentive.title;
        viewSpecialsDetailsEvent(widgetName, windowId, title);
      }
    }
  }, {
    key: "onClose",
    value: function onClose() {
      var _this$props2 = this.props,
          onModalClose = _this$props2.onModalClose,
          _this$props2$widgetIn = _this$props2.widgetInfo,
          windowId = _this$props2$widgetIn.windowId,
          widgetName = _this$props2$widgetIn.widgetName;
      onModalClose(); // Track when modal is closed

      closeSpecialsDetailsEvent(widgetName, windowId);
    }
  }, {
    key: "getOfferType",
    value: function getOfferType(specific, manufacturerOffer, make, accountName) {
      var issuer = accountName;

      if (manufacturerOffer) {
        issuer = make;
      }

      var typeHeading = PROMOTION_FROM;

      if (specific && specific._type) {
        switch (specific._type) {
          case 'CASH':
            typeHeading = CASH_OFFER_FROM;
            break;

          case 'FINANCE':
          case 'UNDEFINED_TERM':
            typeHeading = FINANCE_OFFER_FROM;
            break;

          case 'CASH_AND_FINANCE':
            typeHeading = FINANCE_AND_CASH_OFFER_FROM;
            break;

          case 'CASH_OR_FINANCE':
            typeHeading = FINANCE_OR_CASH_OFFER_FROM;
            break;

          case 'LEASE':
            typeHeading = LEASE_OFFER_FROM;
            break;

          default:
            // PROMOTION
            typeHeading = PROMOTION_FROM;
        }
      }

      return "".concat(this.labels.get(typeHeading), " ").concat(issuer);
    }
  }, {
    key: "getIncentiveDetails",
    value: function getIncentiveDetails() {
      var _this$props3 = this.props,
          incentive = _this$props3.incentive,
          newListingPath = _this$props3.newListingPath,
          usedListingPath = _this$props3.usedListingPath,
          account = _this$props3.account,
          locale = _this$props3.locale,
          prefs = _this$props3.prefs;
      var key = incentive.key,
          specific = incentive.specific,
          title = incentive.title,
          shortTitle = incentive.shortTitle,
          offerDetails = incentive.offerDetails,
          make = incentive.make,
          condition = incentive.condition,
          manufacturerOffer = incentive.manufacturerOffer;

      var _parseIncentiveKey = parseIncentiveKey(key),
          incentiveId = _parseIncentiveKey.incentiveId,
          incentiveAccountId = _parseIncentiveKey.incentiveAccountId;

      var offerType = this.getOfferType(specific, manufacturerOffer, make, account.name);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "mt-2 mb-0 h5",
        "data-testid": "offerType"
      }, offerType), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "mt-0"
      }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "mt-2 mb-0 h5 text-capitalize"
      }, this.labels.get(DETAILS)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, offerDetails), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpecificDetails, {
        incentive: incentive,
        locale: locale,
        prefs: prefs
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListingLink, {
        incentiveId: incentiveId,
        incentiveAccountId: incentiveAccountId,
        incentiveName: shortTitle,
        condition: condition,
        newListingPath: newListingPath,
        usedListingPath: usedListingPath,
        locale: locale
      }));
    }
  }, {
    key: "getIncentiveDisclaimer",
    value: function getIncentiveDisclaimer(disclaimer) {
      var incentiveDisclaimer = null;

      if (disclaimer) {
        incentiveDisclaimer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "text-muted small mt-4"
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "".concat(this.labels.get(DISCLAIMER), ": ").concat(disclaimer)));
      }

      return incentiveDisclaimer;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          incentive = _this$props4.incentive,
          isMobile = _this$props4.isMobile,
          isOpen = _this$props4.isOpen;
      var shortTitle = incentive.shortTitle,
          disclaimer = incentive.disclaimer;
      var incentiveDetails = this.getIncentiveDetails();
      var incentiveDisclaimer = this.getIncentiveDisclaimer(disclaimer);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"], {
        show: isOpen,
        onHide: this.onClose,
        onShow: this.onOpen,
        className: "m-1 ".concat(isMobile ? 'dock-right' : null)
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"].Header, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"].Title, {
        className: "text-center"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        type: "button",
        "aria-label": "Close",
        className: "close text-muted",
        onClick: this.onClose
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
        className: "ddc-icon ddc-icon-close",
        "aria-hidden": "true"
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "h3 my-0 px-5"
      }, shortTitle))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["Modal"].Body, null, incentiveDetails, incentiveDisclaimer));
    }
  }]);

  return IncentiveModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
IncentiveModal.propTypes = {
  incentive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    key: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    offerDetails: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    shortTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disclaimer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    effectiveDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    expirationDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    conditional: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    make: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    condition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    manufacturerOffer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    specific: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired,
  widgetInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    windowId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    widgetName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    deviceType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  isMobile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onModalClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  account: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  newListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  usedListingPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    showEffectiveStartDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  })
};
IncentiveModal.defaultProps = {
  newListingPath: null,
  usedListingPath: null,
  locale: 'en_US',
  prefs: {
    showEffectiveStartDate: 'true'
  }
};


//# sourceMappingURL=es.js.map


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = DDC.WsmCommonData;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = ReduxThunk;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.3e2b2e09cb7826938420.js